var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "node-view-wrapper",
    {
      staticClass: "automation-attribute-tiptap",
      class: { active: _vm.active },
      attrs: { contenteditable: false },
    },
    [
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "automation-attribute-tiptap-popover",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("AutomationAttributePicker", {
                attrs: {
                  "default-selected": _vm.node.attrs.name,
                  pick: _vm.onPicked,
                  "whatsapp-mode": _vm.node.attrs.whatsappMode,
                  automation: _vm.currentAutomation,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "logos pop-content w-100",
              on: {
                click: function ($event) {
                  _vm.active = true
                },
                contextmenu: function ($event) {
                  $event.preventDefault()
                  return _vm.showContextMenu($event)
                },
              },
            },
            [
              _c("AttributeIconPreview", {
                attrs: { attribute: _vm.node.attrs.name },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "ml-2" },
                [
                  _c("AttributeLabel", {
                    attrs: { attribute: _vm.node.attrs.name },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.contextMenuVisible
        ? _c(
            "a-dropdown",
            {
              attrs: { visible: _vm.contextMenuVisible, trigger: [] },
              on: { visibleChange: _vm.onDropdownVisibleChange },
            },
            [
              _c(
                "ul",
                {
                  staticClass: "custom-context-menu",
                  attrs: { slot: "overlay" },
                  slot: "overlay",
                },
                [
                  _c("li", { on: { click: _vm.openEditAttribute } }, [
                    _vm._v(" Düzenle"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { position: "fixed", "z-index": "9999" },
                style: _vm.contextMenuStyle,
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Attribute'ı Elle Düzenle", footer: null },
          on: {
            cancel: function ($event) {
              _vm.editModalVisible = false
            },
          },
          model: {
            value: _vm.editModalVisible,
            callback: function ($$v) {
              _vm.editModalVisible = $$v
            },
            expression: "editModalVisible",
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
            _vm._v("Attribute değerini elle girin:"),
          ]),
          _vm._v(" "),
          _c("a-input", {
            attrs: { placeholder: "block.123.result.sessions.buckets.$..*" },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.saveManualAttribute.apply(null, arguments)
              },
            },
            model: {
              value: _vm.manualAttribute,
              callback: function ($$v) {
                _vm.manualAttribute = $$v
              },
              expression: "manualAttribute",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "16px", "text-align": "right" } },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editModalVisible = false
                    },
                  },
                },
                [_vm._v("İptal")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "8px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.saveManualAttribute },
                },
                [_vm._v("Kaydet")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }